module.exports = __webpack_public_path__ + "static/media/tree-large.cc2447f8.svg";